var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "animated fadeIn"
  }, [(_vm.showCreateMarketVehicleRequest == false) ? _c('b-card', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true",
      "title": "Search Filter"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Create Requested Market Vehicle"
    },
    on: {
      "click": _vm.CreateMarketVehicleRequest
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square-o fa-2x",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "style": "color: red"
    }
  })])])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_vm._v("Facility Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.branchNameList,
      "clearable": false,
      "name": "branchName",
      "placeholder": "Select Facility Name",
      "label": "label",
      "track-by": "id",
      "multiple": true,
      "scroll": true
    },
    model: {
      value: (_vm.branchName),
      callback: function($$v) {
        _vm.branchName = $$v
      },
      expression: "branchName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-book' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.Statuslist,
      "placeholder": "Select Status",
      "append-to-body": true,
      "name": "status"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Requested Creation date range ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "not-after": _vm.disabledAfter,
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "requestedcreationdaterange",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.requestedcreationdaterange),
      callback: function($$v) {
        _vm.requestedcreationdaterange = $$v
      },
      expression: "requestedcreationdaterange"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Requested Rejection/Approval Date range")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar-o'></i>"
    }
  }, [_c('date-picker', {
    attrs: {
      "range": "",
      "not-after": _vm.disabledAfter,
      "shortcuts": _vm.shortcuts,
      "lang": "en",
      "name": "approvalrejectdaterange",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.approvalrejectdaterange),
      callback: function($$v) {
        _vm.approvalrejectdaterange = $$v
      },
      expression: "approvalrejectdaterange"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchRequest
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n\t\t\t\t\t\t\t\t\t\t"), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset\n\t\t\t\t\t\t\t\t\t\t")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3 checkbox",
    staticStyle: {
      "padding": "0px 0px 0px 14px"
    }
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MyApproval),
      expression: "MyApproval"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1",
      "id": "MyApproval",
      "name": "MyApproval"
    },
    domProps: {
      "checked": Array.isArray(_vm.MyApproval) ? _vm._i(_vm.MyApproval, "1") > -1 : (_vm.MyApproval)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.MyApproval,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.MyApproval = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.MyApproval = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.MyApproval = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "1"
    }
  }, [_vm._v("My Approval List")])])])])])], 1)], 1)]), _vm._v(" "), _c('div', [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "header",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Request List\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b', {
    staticStyle: {
      "float": "right",
      "padding-top": "5px"
    }
  }, [_vm._v("Total Records:" + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right",
      "padding-right": "2px"
    },
    attrs: {
      "type": "button",
      "title": "Download (XLSX)"
    },
    on: {
      "click": function($event) {
        _vm.DownloadRequestedData()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tDownload (XLSX)\n\t\t\t\t\t\t")])])]), _vm._v(" "), _c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumn,
      "items": _vm.tableItems,
      "offset": _vm.offset,
      "isEditHidden": true,
      "isViewHidden": true
    },
    on: {
      "customTableEvent": _vm.getCustomTableEvent
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalCount,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  })], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', [(_vm.showCreateMarketVehicleRequest == true) ? _c('div', [(_vm.TripType == 'marketVehicle') ? _c('div', [_c('createmarketvehiclerequest', {
    attrs: {
      "selectedEditRowData": _vm.selectedVehiclereqObj
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.TripType == 'created') ? _c('div', [_c('create-trip-management', {
    attrs: {
      "parentObj": _vm.selectedVehiclereqObj
    },
    on: {
      "goBackToParent": _vm.callParent
    }
  })], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "hide-header-close": true,
      "data-toggle": "modal"
    },
    on: {
      "ok": function($event) {
        _vm.cancelrequest = false
      }
    },
    model: {
      value: (_vm.cancelrequest),
      callback: function($$v) {
        _vm.cancelrequest = $$v
      },
      expression: "cancelrequest"
    }
  }, [_c('b-card', {
    staticClass: "overflow-hidden"
  }, [_c('div', {
    slot: "header"
  }, [_vm._v("\n\t\t\t\tREQUEST ID - " + _vm._s(_vm.requestid) + "\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeCancelrequest
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Branch Name ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CancelbranchName),
      expression: "CancelbranchName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "CancelbranchName",
      "id": "CancelbranchName",
      "placeholder": "branchName",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.CancelbranchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CancelbranchName = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ad-hoc Vehicle Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AdhocVehicleType),
      expression: "AdhocVehicleType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "AdhocVehicleType",
      "id": "AdhocVehicleType",
      "placeholder": "AdhocVehicleType",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.AdhocVehicleType)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AdhocVehicleType = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Estimated Vehicle Load ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.estimatedvehicleload),
      expression: "estimatedvehicleload"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "estimatedvehicleload",
      "id": "estimatedvehicleload",
      "placeholder": "KG",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.estimatedvehicleload)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.estimatedvehicleload = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Reason For Ad-hoc Vehicle ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reasonadhocvehicle),
      expression: "reasonadhocvehicle"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "reasonadhocvehicle",
      "id": "reasonadhocvehicle",
      "placeholder": "Reason to Select Ad-hoc Vehicle",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.reasonadhocvehicle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reasonadhocvehicle = $event.target.value
      }
    }
  })]), _vm._v("\n\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t"), _c('b-input-group', [(this.reasonremarks == true) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addOtherReasonRemarks),
      expression: "addOtherReasonRemarks"
    }],
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "name": "remarksdata",
      "id": "remarksdata",
      "cols": "50",
      "rows": "15",
      "placeholder": "Enter Other Reason Remarks",
      "maxlength": 250,
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.addOtherReasonRemarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addOtherReasonRemarks = $event.target.value
      }
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Vehicle Cost (INR) ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehiclecost),
      expression: "vehiclecost"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "vehiclecost",
      "id": "vehiclecost",
      "placeholder": "Enter Vehicle Cost",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.vehiclecost)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehiclecost = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Route Name ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routename),
      expression: "routename"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "routename",
      "id": "routename",
      "placeholder": "Enter Vehicle Cost",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.routename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.routename = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ad-hoc Vehicle Number ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adhocvehiclenumber),
      expression: "adhocvehiclenumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "adhocvehiclenumber",
      "id": "adhocvehiclenumber",
      "placeholder": "Enter Ad-hoc Vehicle Number",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.adhocvehiclenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adhocvehiclenumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "vehiclenote"
    }
  }, [_vm._v("Note: Allowed Vehicle Number Format 'XX\n\t\t\t\t\t\t\t\t00 XX 0000' or 'XX 00 X 0000' or 'XX 00 XXX 0000'.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Upload Proof of Approval\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "View Image"
    },
    on: {
      "click": function($event) {
        _vm.viewSelectedImage(_vm.rowid, 'document')
      }
    }
  }, [_c('img', {
    attrs: {
      "height": "16",
      "width": "16",
      "src": "/static/img/ViewImage.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.cancelApprovalRequest()
      }
    }
  }, [_vm._v(" CANCEL Request"), _c('i', {
    staticClass: "fa fa-print"
  })])])])])])]), _vm._v(" "), (this.cancelrequest == true) ? _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myuploadImg",
      "id": 'imguploadid' + _vm.uploadimage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myuploadModalImg' + _vm.uploadimage
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal2('myuploadModalImg' + _vm.uploadimage)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "35px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'captionImg' + _vm.uploadimageCaption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'uploadimg' + _vm.uploadimage,
      "src": _vm.uploadimage
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "data-toggle": "modal",
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "hide-header-close": true
    },
    on: {
      "ok": function($event) {
        _vm.viewrequest = false
      }
    },
    model: {
      value: (_vm.viewrequest),
      callback: function($$v) {
        _vm.viewrequest = $$v
      },
      expression: "viewrequest"
    }
  }, [_c('b-card', {
    staticClass: "overflow-hidden"
  }, [_c('div', {
    slot: "header"
  }, [_vm._v("\n\t\t\t\tREQUEST ID - " + _vm._s(this.requestid) + "\n\t\t\t\t"), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeViewrequest
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Branch Name ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestbranchName),
      expression: "requestbranchName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "requestbranchName",
      "id": "requestbranchName",
      "placeholder": "branchName",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.requestbranchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.requestbranchName = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ad-hoc Vehicle Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.AdhocVehicleList,
      "clearable": false,
      "name": "AdhocVehicleType",
      "placeholder": "Select Ad-hoc Vehicle Type",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "disabled": _vm.editRequestDetails == false || _vm.enableApproveRejectbtn == false
    },
    on: {
      "select": _vm.selectedViewVehicleType
    },
    model: {
      value: (_vm.ViewAdhocVehicleType),
      callback: function($$v) {
        _vm.ViewAdhocVehicleType = $$v
      },
      expression: "ViewAdhocVehicleType"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Estimated Vehicle Load ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.estimatedvehicleload),
      expression: "estimatedvehicleload"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "estimatedvehicleload",
      "id": "estimatedvehicleload",
      "placeholder": "KG",
      "min": 1,
      "disabled": _vm.editRequestDetails == false || _vm.enableApproveRejectbtn == false
    },
    domProps: {
      "value": (_vm.estimatedvehicleload)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.estimatedvehicleload = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Reason For Ad-hoc Vehicle ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reasonadhocvehicle),
      expression: "reasonadhocvehicle"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "reasonadhocvehicle",
      "id": "reasonadhocvehicle",
      "placeholder": "Reason to Select Ad-hoc Vehicle",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.reasonadhocvehicle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reasonadhocvehicle = $event.target.value
      }
    }
  })]), _vm._v("\n\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t"), _c('b-input-group', [(this.reasonremarks == true) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addOtherReasonRemarks),
      expression: "addOtherReasonRemarks"
    }],
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "name": "remarksdata",
      "id": "remarksdata",
      "cols": "50",
      "rows": "15",
      "placeholder": "Enter Other Reason Remarks",
      "maxlength": 250,
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.addOtherReasonRemarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addOtherReasonRemarks = $event.target.value
      }
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Vehicle Cost (INR) ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehiclecost),
      expression: "vehiclecost"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "min": 1,
      "name": "vehiclecost",
      "id": "vehiclecost",
      "placeholder": "Enter Vehicle Cost",
      "disabled": _vm.editRequestDetails == false || _vm.enableApproveRejectbtn == false
    },
    domProps: {
      "value": (_vm.vehiclecost)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehiclecost = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Route Name ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.routename),
      expression: "routename"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "routename",
      "id": "routename",
      "placeholder": "Route Name",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.routename)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.routename = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ad-hoc Vehicle Number ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adhocvehiclenumber),
      expression: "adhocvehiclenumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "adhocvehiclenumber",
      "id": "adhocvehiclenumber",
      "placeholder": "Enter Ad-hoc Vehicle Number",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.adhocvehiclenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adhocvehiclenumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "vehiclenote"
    }
  }, [_vm._v("Note: Allowed Vehicle Number Format 'XX\n\t\t\t\t\t\t\t\t00 XX 0000' or 'XX 00 X 0000' or 'XX 00 XXX 0000'.")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.vehicleNoErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Upload Pan Card Image\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "View Image"
    },
    on: {
      "click": function($event) {
        _vm.viewSelectedImage(_vm.rowid, 'pancard')
      }
    }
  }, [_c('img', {
    attrs: {
      "height": "16",
      "width": "16",
      "src": "/static/img/ViewImage.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Upload Proof of Approval\n\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "View Image"
    },
    on: {
      "click": function($event) {
        _vm.viewSelectedImage(_vm.rowid, 'document')
      }
    }
  }, [_c('img', {
    attrs: {
      "height": "16",
      "width": "16",
      "src": "/static/img/ViewImage.png"
    }
  })])]), _vm._v(" "), (this.approvalstatus == 0) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit",
      "disabled": this.enableApproveRejectbtn == false
    },
    on: {
      "click": function($event) {
        _vm.ApprovalRequest($event)
      }
    }
  }, [_vm._v(" APPROVE "), _c('i', {
    staticClass: "fa fa-print"
  })]), _vm._v("\n\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t"), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "disabled": this.enableApproveRejectbtn == false
    },
    on: {
      "click": function($event) {
        _vm.Rejectrequest($event)
      }
    }
  }, [_vm._v(" REJECT "), _c('i', {
    staticClass: "fa fa-refresh"
  })])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-hidden",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('legend', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Approval User History")]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('th', [_vm._v("Level")]), _vm._v(" "), _c('th', [_vm._v("User Name")]), _vm._v(" "), _c('th', [_vm._v("Approved/Rejected By")]), _vm._v(" "), _c('th', [_vm._v("Status")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "fixed-column"
  }, [_vm._l((_vm.approverUserData), function(data, index) {
    return [_c('tr', {
      class: {
        'rowtype1': data.approvalstatus == 'Approved',
        'rowtype2': data.approvalstatus == 'Rejected'
      },
      staticStyle: {
        "width": "100%"
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.userId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.approvalstatus == 'Approved' ? data.approvedby : data.rejectedby))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.approvalstatus))])])]
  }), _vm._v(" "), (_vm.approverUserData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "12",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rejectRequest == true),
      expression: "rejectRequest==true"
    }]
  }, [_c('b-card', {
    staticClass: "overflow-hidden",
    attrs: {
      "size": "md"
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('span', [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "600"
    }
  }, [_vm._v("Please select reason of rejection")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-asterisk' style='font-size: 12px'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "multiple": false,
      "max-height": 150,
      "clearable": false,
      "options": _vm.rejectrequestreasonlist,
      "placeholder": "Select Reason",
      "append-to-body": true,
      "label": "label",
      "track-by": "id",
      "name": "rejectrequestreason"
    },
    on: {
      "select": _vm.selectRejectReason
    },
    model: {
      value: (_vm.rejectrequestreason),
      callback: function($$v) {
        _vm.rejectrequestreason = $$v
      },
      expression: "rejectrequestreason"
    }
  })], 1), _vm._v("\n\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t"), _c('b-input-group', [(this.rejectreasonremarks == true) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rejectOtherReasonRemarks),
      expression: "rejectOtherReasonRemarks"
    }],
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "name": "remarksdata",
      "id": "remarksdata",
      "cols": "50",
      "rows": "15",
      "placeholder": "Enter Other Rejection Reason Remarks",
      "maxlength": 250
    },
    domProps: {
      "value": (_vm.rejectOtherReasonRemarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rejectOtherReasonRemarks = $event.target.value
      }
    }
  }) : _vm._e()])], 1)])])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.submitRejectRequestReason()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tSubmit")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetRejectRequestReason($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tClose")])])])])], 1), _vm._v(" "), (this.viewrequest == true) ? _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myuploadImg",
      "id": 'imguploadid' + _vm.uploadimage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myuploadModalImg' + _vm.uploadimage
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal2('myuploadModalImg' + _vm.uploadimage)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "35px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'captionImg' + _vm.uploadimageCaption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'uploadimg' + _vm.uploadimage,
      "src": _vm.uploadimage
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])]) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "lg",
      "data-toggle": "modal",
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "hide-header-close": true
    },
    on: {
      "ok": function($event) {
        _vm.poaImages = false
      }
    },
    model: {
      value: (_vm.poaImages),
      callback: function($$v) {
        _vm.poaImages = $$v
      },
      expression: "poaImages"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('b', [_vm._v("POA Images ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closePoaImages
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', [_vm._v("Proof Of Approval Image\n\t\t\t\t\t\t"), _c('div', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("(Click on the image to view it)")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.poaimagearray), function(item) {
    return _c('div', {
      staticClass: "col-md-5"
    }, [_c('br'), _vm._v(" "), (item) ? _c('img', {
      staticStyle: {
        "cursor": "pointer",
        "width": "65px",
        "margin-left": "9rem",
        "height": "65px"
      },
      attrs: {
        "src": item,
        "alt": "NO Image",
        "title": "Open Image"
      },
      on: {
        "click": function($event) {
          _vm.openImage(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item) ? _c('i', {
      staticClass: "fa fa-download",
      staticStyle: {
        "cursor": "pointer",
        "font-size": "1rem",
        "margin-left": "20px",
        "margin-right": "10px",
        "margin-top": "1rem"
      },
      attrs: {
        "aria-hidden": "true",
        "title": "Download Image"
      },
      on: {
        "click": function($event) {
          _vm.fileview(item)
        }
      }
    }) : _vm._e()])
  }))])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md",
      "data-toggle": "modal",
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "hide-header-close": true
    },
    on: {
      "ok": function($event) {
        _vm.VisbilityChanges = false
      }
    },
    model: {
      value: (_vm.VisbilityChanges),
      callback: function($$v) {
        _vm.VisbilityChanges = $$v
      },
      expression: "VisbilityChanges"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('b', [_vm._v("Approval Details Changes ")])]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeVisbilityChanges
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v("Visibility of changes done to a request during approval")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "overflow-y:auto"
  }, [_c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%",
      "padding": "5px"
    },
    attrs: {
      "id": "AdhocVehicleChanges"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Approval Request Changes")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Before")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("After")])])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('tr', [_c('td', [_vm._v("Vehicle Cost:")]), _vm._v(" "), _c('td', [(this.selectedVehiclereqObj && this.selectedVehiclereqObj.requestedvehiclecost) ? _c('span', [_vm._v("RS " + _vm._s(this.selectedVehiclereqObj.requestedvehiclecost))]) : _vm._e()]), _c('td', [(this.selectedVehiclereqObj && this.selectedVehiclereqObj.approvedvehiclecost !== this.selectedVehiclereqObj.requestedvehiclecost) ? _c('span', [_vm._v("RS " + _vm._s(this.selectedVehiclereqObj.approvedvehiclecost))]) : _c('span', [_vm._v(" No Changes")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vehicle Type:")]), _vm._v(" "), _c('td', [(this.selectedVehiclereqObj && this.selectedVehiclereqObj.requestedvehicletype) ? _c('span', [_vm._v(_vm._s(this.selectedVehiclereqObj.requestedvehicletype))]) : _vm._e()]), _vm._v(" "), _c('td', [(this.selectedVehiclereqObj && this.selectedVehiclereqObj.approvedvehicletype !== this.selectedVehiclereqObj.requestedvehicletype) ? _c('span', [_vm._v(_vm._s(this.selectedVehiclereqObj.approvedvehicletype))]) : _c('span', [_vm._v(" No Changes")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Vehicle Load: ")]), _vm._v(" "), _c('td', [(this.selectedVehiclereqObj && this.selectedVehiclereqObj.requestedvehicleload) ? _c('span', [_vm._v("KG " + _vm._s(this.selectedVehiclereqObj.requestedvehicleload))]) : _vm._e()]), _vm._v(" "), _c('td', [(this.selectedVehiclereqObj && this.selectedVehiclereqObj.approvedvehicleload !== this.selectedVehiclereqObj.requestedvehicleload) ? _c('span', [_vm._v("KG " + _vm._s(this.selectedVehiclereqObj.approvedvehicleload))]) : _c('span', [_vm._v(" No Changes")])])])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "submit",
      "title": "Create trip of the Req. Id"
    },
    on: {
      "click": _vm.createRequestedvehicleTrip
    }
  }, [_vm._v(" Proceed "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.closeVisbilityChanges
    }
  }, [_vm._v(" Close "), _c('i', {
    staticClass: "fa fa-print"
  })])])])])], 1), _vm._v(" "), _c('section', [_c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "300px"
    },
    attrs: {
      "id": "myImg",
      "id": 'imgid' + _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal",
    attrs: {
      "id": 'myModalImg' + _vm.image
    }
  }, [_c('span', {
    staticClass: "closemodel",
    staticStyle: {
      "cursor": "pointer",
      "float": "right",
      "margin-right": "30px"
    },
    attrs: {
      "title": "Close Image"
    },
    on: {
      "click": function($event) {
        _vm.closemodal('myModalImg' + _vm.image)
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "rgb(204, 204, 204)",
      "padding": "0px 0px",
      "height": "35px",
      "font-size": "20px!important"
    },
    attrs: {
      "id": 'captionImg' + _vm.caption
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "modal-content1",
    attrs: {
      "id": 'img' + _vm.image,
      "src": _vm.image
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "auto",
      "display": "block",
      "width": "80%",
      "max-width": "700px",
      "text-align": "center",
      "color": "#ccc",
      "padding": "10px 0",
      "height": "150px"
    }
  })])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49040d89","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/marketvehicleflm/marketvehiclelist/marketvehiclelist.component.html
// module id = 1990
// module chunks = 3